var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.25031 10.0007C3.92031 10.0007 3.60156 9.87072 3.36656 9.63447L0.866562 7.13447C0.377812 6.64572 0.377812 5.85572 0.866562 5.36697C1.35531 4.87822 2.14531 4.87822 2.63406 5.36697L4.05656 6.78947L8.21031 0.556966C8.59281 -0.0180344 9.36781 -0.173034 9.94406 0.210716C10.5178 0.594466 10.6728 1.36947 10.2903 1.94447L5.29031 9.44447C5.08281 9.75572 4.74531 9.95822 4.37406 9.99447C4.33156 9.99822 4.29156 10.0007 4.25031 10.0007Z",
    fill: "#16A34A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGood);
export default __webpack_public_path__ + "static/media/good.a4dcf79b9c4461ba7a5588be23933f52.svg";
export { ForwardRef as ReactComponent };